/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-01-07 11:18:42
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Modal } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { InlineWidget } from 'react-calendly';

type Props = {
  handleChangeModal: () => void,
  activeScheduleDemoModal: boolean
};

type ComposedProps = Props & WithI18nProps;

class ScheduleDemo extends Component<ComposedProps> {
  render() {
    const { activeScheduleDemoModal, handleChangeModal, i18n } = this.props;

    return (
      <Modal
        open={activeScheduleDemoModal}
        onClose={handleChangeModal}
        noScroll
        title={i18n.translate('AdminHTML.Dashboard.Common.scheduleDemo')}>
        {/* Calendly inline widget begin */}
        <InlineWidget
          url="https://calendly.com/boost-commerce-support/30min"
          styles={{
            height: 'calc(100vh - 200px)',
            maxHeight: '650px',
            minWidth: '320px'
          }}
        />
        {/* Calendly inline widget end*/}
      </Modal>
    );
  }
}

export default withI18n()(ScheduleDemo);
